import {shownName} from './profileTheme';
import React from 'react';
import {CheckCheck, UserPlus, X} from 'lucide-react';
import {useLang} from './i18n';
import './friend-notice.css';

export type FriendshipNotice = {kind: 'request' | 'accepted'; person: {id: string; displayName: string; username: string}};

export function FriendNotice({notice, onOpen, onClose}: {notice: FriendshipNotice; onOpen: () => void; onClose: () => void}) {
  const [,,tr] = useLang();
  const incoming = notice.kind === 'request';
  return <aside className="friend-notice" aria-label={tr('Friendship notification', 'Freundschaftsbenachrichtigung')}>
    <div className="friend-notice-copy" role="status">
      {incoming ? <UserPlus size={20} aria-hidden="true"/> : <CheckCheck size={20} aria-hidden="true"/>}
      <div><strong>{incoming ? tr('New friend request', 'Neue Freundschaftsanfrage') : tr('Friend request accepted', 'Freundschaftsanfrage angenommen')}</strong>
        <p>{shownName(notice.person)}{incoming ? tr(' would like to add you as a friend.', ' möchte dich als Freund hinzufügen.') : tr(' accepted your friend request. You can chat now!', ' hat deine Freundschaftsanfrage angenommen. Ihr könnt jetzt chatten!')}</p>
      </div>
    </div>
    <button type="button" className="friend-notice-close" aria-label={tr('Dismiss notification', 'Benachrichtigung schließen')} onClick={onClose}><X size={16}/></button>
    <button type="button" className="friend-notice-action" onClick={onOpen}>{incoming ? tr('View requests', 'Anfragen ansehen') : tr('Open chat', 'Chat öffnen')}</button>
  </aside>;
}
